const basicInfoFields = [
  {
    name: 'name',
    showKey: 'name',
    label: 'Nama Template',
    placeholder: 'Masukkan Nama Template',
    type: 'text',
    validation: 'bail|required|max:256,length',
    col: 'col-3',
  },
  {
    name: 'description',
    showKey: 'description',
    label: 'Deskripsi',
    placeholder: 'Masukkan Deskripsi',
    type: 'text',
    validation: 'bail|max:256,length',
    col: 'col-6',
  },
]

export default basicInfoFields